<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-input :model="filterFormModel" attribute="brandName" class="mr-1 mb-1" :placeholder="$t('inputBrandName')"></form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="month" :options="[
                {value: null, text: $t('chooseMonth')},
                {value: 1, text: 1},
                {value: 2, text: 2},
                {value: 3, text: 3},
                {value: 4, text: 4},
                {value: 5, text: 5},
                {value: 6, text: 6},
                {value: 7, text: 7},
                {value: 8, text: 8},
                {value: 9, text: 9},
                {value: 10, text: 10},
                {value: 11, text: 11},
                {value: 12, text: 12},
            ]"></form-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.year" v-on:keydown.enter="load"
                          :placeholder="$t('year')"></b-form-input>
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('chargedTime')"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['admin', 'owner', 'account', 'operationsManager', 'accountant'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('client') }}</div>
            <div class="col-lg-3">{{ $t('brandName') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-2">{{ $t('amount') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>
              <span>{{ item.client.companyName }} ({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-3">
              <p>
                <b class="c-smart-table__label">{{ $t('brandName') }}:&nbsp;</b>
                <span>{{ $t(item.brandName.name) }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <div>
                <b>{{ $t('month') }}: </b>
                <span>{{ item.month }}/{{ item.year }}</span>
              </div>
              <div>
                <b>{{ $t('chargedTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
            </div>
            <div class="col-lg-2">
              <p>
                <b class="c-smart-table__label">{{ $t('amount') }}: </b>
                <span>{{ item.amount | numFormat }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="lg" v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-select :model="formModel" :label="$t('brandName')" attribute="brandName" :errors="formErrors" :options="brandNames"></form-select>
      <label>{{$t('time')}}</label><br>
      <time-picker :model="formModel" attribute="time" :errors="formErrors" unit="month" class="mb-2"></time-picker>
      <form-input :label="$t('amount')" :model="formModel" attribute="amount" :errors="formErrors"></form-input>
    </b-modal>
  </main>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";
import TimePicker from "@/components/TimePicker";
import _ from 'lodash';

export default {
  components: {
    ClientSelect, TimePicker
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/sms-brand-name-subscription-transaction',
      autoLoad: true,
      defaultFilterFormModel: {
        month: null,
        year: null,
        type: null
      },
      defaultFormModel: {
        brandName: null,
        time: Date.now(),
        amount: 200000
      },
      brandNames: []
    }
  },
  mounted() {
    this.getBrandNames();
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    getBrandNames() {
      this.brandNames = [{value: null, text: this.$t('chooseBrandName')}];
      this.$service.get('/sms-brand-name', {params: {
          page: 1, pageSize: 1000, case: 2
        }
      }).then(response => {
        if (response && response.data && response.data.docs) {
          response.data.docs.forEach(b => {
            this.brandNames.push({value: b._id, text: b.name})
          })
        }
      })
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'SMS brand name subscription transaction',
        month: 'Month',
        year: 'Year',
        amount: 'Amount',
        chargedTime: 'Charged time',
        info: 'Info',
        phoneSubscription: 'Phone number subscription fee',
        inputBrandName: 'Input brand name',
        chooseMonth: 'Choose month',
        chooseBrandName: 'Choose brand name'
      },
      vi: {
        title: 'Phí duy trì brand name',
        month: 'Tháng',
        year: 'Năm',
        amount: 'Số tiền',
        chargedTime: 'Tính tiền lúc',
        info: 'Thông tin',
        brandName: 'Brand name',
        phoneSubscription: 'Phí thuê bao điện thoại',
        inputBrandName: 'Nhập brand name',
        chooseMonth: 'Chọn tháng',
        chooseBrandName: 'Chọn brand name'
      }
    }
  }
}
</script>